export default __webpack_public_path__ + "static/media/avatar.ce70d772.svg";